import { useMutation } from "@apollo/client";
import { serverGql } from "__generated__/serverGql";
import useAsyncCompleteToast from "components/Shared/useAsyncCompleteToast";
import serverClient from "utils/apollo/serverClient";

const mutation = serverGql(/* ServerGraphQL */ `
  mutation CompleteSignupPlanSelection($brandId: UUID!, $accessPlanId: UUID!) {
    completeSignupPlanSelection(
      brandId: $brandId
      accessPlanId: $accessPlanId
    ) {
      brand {
        id
        accessPlanId
        isSubscriptionValid
        stripeSubscriptionId
      }
    }
  }
`);

type CompleteSignupPlanSelectionParams = {
  accessPlanId: UUID;
  brandId: UUID;
};

export default function useCompleteSignupPlanSelection() {
  const { showErrorToast } = useAsyncCompleteToast();
  const [completePlanSelection, { loading: isLoading }] = useMutation(
    mutation,
    {
      client: serverClient,
      onError: (error) => {
        showErrorToast(error);
      },
    },
  );

  const completeSignupPlanSelection = async ({
    accessPlanId,
    brandId,
  }: CompleteSignupPlanSelectionParams) => {
    await completePlanSelection({ variables: { accessPlanId, brandId } });
  };

  return { completeSignupPlanSelection, isLoading };
}
